import { Event } from '../Event'
import { Identity } from '../../constants'
import { SellableProperties } from './types'

export interface ProductViewedEventProperties extends SellableProperties {}

export class ProductViewedEvent extends Event<ProductViewedEventProperties> {
  static displayName = 'Product Viewed'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
